import React from 'react';

function NotFound() {
    return ( 
        /*this is pasted from the hero.js since it was the same format with only minute changes*/
    <div className='container p-5 text-center mb-5'>
            <div className='row'>

            <h1 className='mt-5'>404 Not Found </h1>

            <p>Sorry, the page that your looking for does not exits</p>
           
            </div>
        </div> 
);
}

export default NotFound;